module.exports = __webpack_public_path__ + "static/media/mushroommovie_sad.4df26608.gif";